import React, { useState } from "react";
import { usePagination } from "../../../hooks";
import { AdminSharedHeader, AdminSharedTable, AdminSharedDeleteModal } from "../../Admin/Shared";
import { useDelete } from "../../../hooks";
import {
  useGetVendorsQuery,
  useDeleteVendorMutation,
} from "../../../containers/ManagementPortal/services";
import { getLocalizedString } from "../../../shared/translation";
import { VendorForm } from "./Form";

export const VendorContainer = () => {
  const { page, setPage, perPage, pagination } = usePagination();

  const queryParams = {
    page: page,
    per_page: perPage,
    order_by: "created_at",
    order_dir: "desc",
  };

  const {
    data = { data: [], total_count: 0 },
    isFetching,
    isSuccess,
    error,
  } = useGetVendorsQuery({
    ...queryParams,
  });

  const {
    deleteItem: deleteVendor,
    deleteErrorMsg,
    setDeleteErrorMsg,
  } = useDelete({
    deleteMutation: useDeleteVendorMutation,
    closeModal: () => setShowDeleteWarning(false),
  });

  const [idToEdit, setIdToEdit] = useState(null);
  const [idToDelete, setIdToDelete] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);

  const createNewHandler = () => {
    setShowForm(true);
    setIdToEdit(null);
  };

  const editClickHandler = (datum) => {
    setShowForm(true);
    setIdToEdit(datum.id);
  };

  const deleteClickHandler = (datum) => {
    setShowDeleteWarning(true);
    setIdToDelete(datum.id);
  };

  const headers = [
    { label: getLocalizedString("name", "Name"), key: "vendor_name", className: "vendor-name" },
    { label: getLocalizedString("tagName", "Tag Name"), key: "tag_name", className: "tag-name" },
    {
      label: getLocalizedString("addedOn", "Added On"),
      key: "created_at",
      className: "date",
    },
  ];

  const getDeleteItemName = (id) => {
    let name = "";
    const index = data?.data?.findIndex((datum) => datum.id === id);

    if (index > -1) {
      name = data?.data[index].vendor_name;
    }
    return name;
  };

  return (
    <>
      <article className="main-container">
        <AdminSharedHeader
          createNewHandler={createNewHandler}
          heading="Vendors"
        />
        <AdminSharedTable
          isLoading={isFetching}
          error={error}
          isSuccess={isSuccess}
          data={data.data}
          headers={headers}
          pagination={{ ...pagination, count: data.total_count }}
          className="vendors"
          onEdit={editClickHandler}
          systemDefault={false}
          onDelete={deleteClickHandler}
        />
      </article>

      {showForm && <VendorForm idToEdit={idToEdit} closeForm={() => setShowForm(false)} />}

      <AdminSharedDeleteModal
        show={showDeleteWarning}
        error={deleteErrorMsg}
        resourceName="vendor"
        getDeleteItemName={() => getDeleteItemName(idToDelete)}
        onHide={() => {
          setDeleteErrorMsg("");
          setShowDeleteWarning(false);
        }}
        onDelete={() => deleteVendor({ id: idToDelete })}
      />
    </>
  );
};
